import React from 'react'
import PropTypes from 'prop-types'
import { getNotificationContent } from '../content'
import { relativeTimeParts } from '../relativeTime'

const RoomsWithoutImagesDetail = ({ notification, onReviewRooms, t }) => {
  const { title, body } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)

  return (
    <React.Fragment>
      <div className="NotificationDetail-Category NotificationDetail-Category--warning">
        {t('notificationCenter.types.roomsWithoutImages.category')}
      </div>
      <div className="NotificationDetail-Summary">
        <p className="NotificationDetail-Summary-Title">{title}</p>
        <p className="NotificationDetail-Summary-Time">{t(time.key, time.options)}</p>
      </div>
      {body && <p className="NotificationDetail-Description">{body}</p>}
      <button type="button" className="NotificationDetail-ReviewButton" onClick={onReviewRooms}>
        {t('notificationCenter.types.roomsWithoutImages.reviewAction')}
      </button>
    </React.Fragment>
  )
}

RoomsWithoutImagesDetail.propTypes = {
  notification: PropTypes.object.isRequired,
  onReviewRooms: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default RoomsWithoutImagesDetail
